<app-loader *ngIf="loaderIcon$ | async"></app-loader>
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" *ngIf="!disProcDayEnd" [userPermissionHandler]="viewPermissionHandlerData">
            <h5 class="fw-bold mb-0">Day End Process</h5>
            <hr />
            <div class="filter-row d-flex align-items-center justify-content-between">
                <!-- Left: radio group -->
                <div class="d-flex align-items-center">
                    <div class="form-check me-3 me-lg-5">
                        <input class="form-check-input" type="radio" name="statusFilter" id="rAll"
                            [(ngModel)]="activeTab" value="All" (change)="applyDayEndFilter(activeTab)">
                        <span class="radio-custom"></span>
                        <label class="form-check-label radio-label mb-0" for="rAll">All</label>
                    </div>

                    <div class="form-check me-3 me-lg-5">
                        <input class="form-check-input" type="radio" name="statusFilter" id="rPending"
                            [(ngModel)]="activeTab" value="Pending" (change)="applyDayEndFilter(activeTab)">
                        <span class="radio-custom"></span>
                        <label class="form-check-label radio-label mb-0" for="rPending">Pending</label>
                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="statusFilter" id="rCompleted"
                            [(ngModel)]="activeTab" value="Completed" (change)="applyDayEndFilter(activeTab)">
                        <span class="radio-custom"></span>
                        <label class="form-check-label radio-label mb-0" for="rCompleted">Completed</label>
                    </div>
                </div>
                <div class="d-flex align-items-center gap-4 flex-wrap">
                    <div class="d-flex align-items-center">
                        <label for="fromDate" class="me-2 fw-normal" style="width: 6rem">From Date</label>
                        <div class="input-group">
                            <ejs-datepicker class="form-control p-0" [(ngModel)]="fromDate"
                                (ngModelChange)="onDateChange()" [max]="maxExpiryDate"></ejs-datepicker>
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <label for="toDate" class="me-2 fw-normal" style="width: 6rem;">To Date</label>
                        <div class="input-group">
                            <ejs-datepicker class="form-control p-0" [(ngModel)]="toDate"
                                (ngModelChange)="onDateChange()" [min]="minExpiryDate"
                                [max]="maxExpiryDate"></ejs-datepicker>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col-12 text-start mt-2">
                    <ejs-grid [dataSource]='dayEndData' height="350">
                        <e-columns>
                            <e-column field='Terminal' headerText='Terminal' width='120'></e-column>
                            <e-column field='UserName' headerText='User' width='150'></e-column>
                            <e-column field='Date' headerText='Date' width='120' format="MM/dd/yyyy"></e-column>
                            <e-column field='OpeningCash' headerText='Opening Cash' width='150' textAlign='Right'
                                format='C2'></e-column>
                            <e-column field='DayEndStatus' headerText='Day End' width='120'></e-column>
                            <e-column headerText='Process Day End' width='180' textAlign='Center'>
                                <ng-template #template let-data>
                                    <ejs-tooltip id='tooltipdayEnd' target="#targetDayEnd" position="TopCenter"
                                        (beforeOpen)="onBeforeOpen($event)" [content]="
                                            data.DayEndStatus === 'Completed'
                                            ? 'You do not have rights to modify'
                                            : 'You do not have rights to process Day End'
                                        ">
                                        <button class="btn btn-orange btn-sm" id="targetDayEnd"
                                            (click)="onProcessDayEnd(data)"
                                            [disabled]="data.DayEndStatus === 'Completed' && !isSuperUser"
                                            [userPermissionHandler]="
                                            data.DayEndStatus === 'Completed'? editPermissionHandlerData : createPermissionHandlerData
                                        ">
                                            {{data.DayEndStatus === 'Completed' ? 'Modify Day End' : 'Process Day End'
                                            }}
                                        </button>
                                    </ejs-tooltip>
                                </ng-template>
                            </e-column>
                            <e-column headerText='Cancel Day End Process' width='200' textAlign='Center'>
                                <ng-template #template let-data>
                                    <button class="btn btn-orange btn-sm" (click)="cancelDayEndProcess(data)"
                                        [disabled]="data.DayEndStatus !== 'Completed' || ( !isToday(data.Date) && !(isSuperUser && editRight))">Cancel</button>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-end mt-2">
                    <!-- <button class="btn btnAS me-1">Save</button> -->
                    <button class="btn btn-orange" type="button" (click)="onDayEndPageCancel()">Cancel</button>
                </div>
            </div>
        </div>
        <div class="content-area" *ngIf="disProcDayEnd">
            <h5 class="fw-bold mb-0">Process Day End</h5>
            <hr />
            <div class="row">
                <div class="col-md-12 col-lg-3 text-start mt-2">
                    <div class="card p-1 h-100" [formGroup]="dayEndForm">
                        <div class="mb-2">
                            <label for="date" class="form-label mb-0">Date</label>
                            <ejs-datepicker class="form-control p-0" formControlName="Date" [format]="'MM/dd/yyyy'"
                                [readonly]="true"></ejs-datepicker>
                        </div>

                        <div class="mb-2">
                            <label for="username" class="form-label mb-0">User Name</label>
                            <input type="text" class="form-control" id="username" formControlName="UserName" readonly>
                        </div>

                        <div class="mb-2">
                            <label for="terminal" class="form-label mb-0">Terminal</label>
                            <input type="text" class="form-control" id="terminal" formControlName="TerminalName"
                                readonly>
                        </div>

                        <div class="mb-2">
                            <label for="openingCash" class="form-label mb-0">Opening Cash Amount</label>
                            <input type="text" class="form-control text-end" id="openingCash"
                                formControlName="OpeningCashAmount" [appTwoDigitDecimal]='decimalRestrictInput'
                                readonly>
                        </div>

                        <div class="mb-2">
                            <label for="pettyCash" class="form-label mb-0">Petty Cash Expenses</label>
                            <input type="text" class="form-control text-end" id="pettyCash"
                                formControlName="PettyCashAmount" [appTwoDigitDecimal]='decimalRestrictInput' readonly>
                        </div>

                        <div *ngIf="isAnyCashRoundingEnabled" class="mb-2">
                            <label for="roundingAmt" class="form-label mb-0">Rounding Off Amount</label>
                            <input type="text" class="form-control text-end" id="roundingAmt"
                                formControlName="RoundingOffAmount" readonly>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-3"></div>
                <div class="col-md-12 col-lg-6 text-start mt-2">
                    <div class="card p-2 h-100">
                        <h6 class="mb-2">Coins and Bills</h6>
                        <ejs-grid style="height: 100%" height="310px" #gridCoinsBills [dataSource]="listCoinsAndBills">
                            <e-columns>
                                <e-column field="Name" [isPrimaryKey]=true headerText="Coin/Bill"
                                    width="200"></e-column>
                                <e-column field="Count" headerText="Count" width="150" editType="numericedit"
                                    textAlign="Center">
                                    <ng-template #template let-data>
                                        <input class="e-field e-ejinputtext form-control form-control-sm d-inline"
                                            style="text-align: center;width:65%;" type='text' maxlength="5"
                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                            [(ngModel)]="data.Count" (keyup)="calculateTotalCost(data, $event)"
                                            (change)="calculateTotalCost(data, $event)" (blur)="onCountBlur(data)"
                                            (focus)="onCountFocus(data)">
                                    </ng-template>
                                </e-column>
                                <e-column field="Amount" headerText="Amount" width="150" textAlign="Right" format="C2"
                                    editType="numericedit"></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-start my-2">
                    <div class="card p-2">
                        <h6 class="mb-2">Closing Amounts</h6>
                        <ejs-grid #gridCloseAmt [dataSource]="gridClosingAmt" [height]="250">
                            <e-columns>
                                <e-column field="type" [isPrimaryKey]=true headerText="Type" width="150"
                                    textAlign="Left"></e-column>
                                <e-column field="terminalRent" headerText="Terminal Rent" width="150" textAlign="Right"
                                    type="number" format="$#,##0.00;($#,##0.00)">
                                </e-column>
                                <e-column field="terminalPOS" headerText="Terminal POS" width="150" textAlign="Right"
                                    type="number" format="$#,##0.00;($#,##0.00)">
                                </e-column>
                                <e-column field="netTerminal" headerText="Net Terminal" width="150" textAlign="Right"
                                    type="number" format="$#,##0.00;($#,##0.00)">
                                </e-column>
                                <e-column field="actualAmount" headerText="Actual Amount" width="160" textAlign="Right"
                                    editType="numericedit">
                                    <ng-template #template let-data>
                                        <input class="e-field e-ejinputtext form-control form-control-sm d-inline"
                                            style="text-align: right;width:100%;" type='text'
                                            [ngModel]="formatCurrency(data.actualAmount)"
                                            (input)="restrictCurrencyInput($event); onActualAmountChange($event, data)"
                                            (focus)="onActualAmountFocus($event, data)"
                                            (blur)="onActualAmountBlur($event, data)">
                                    </ng-template>
                                </e-column>
                                <e-column field="difference" headerText="Difference" width="120" textAlign="Right"
                                    type="number" format="$#,##0.00;($#,##0.00)">
                                </e-column>
                                <e-column field="reason" headerText="Reason For Difference" width="300" textAlign="Left"
                                    editType="stringedit"> <ng-template #template let-data>
                                        <input class="e-field e-ejinputtext form-control form-control-sm d-inline"
                                            style="text-align: left;width:100%;" type='text' maxlength="50"
                                            [ngModel]="data.reason" (ngModelChange)="onReasonChange($event, data)">
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-end mb-2">
                    <button class="btn btnAS me-1" type="button" (click)="saveDayEndProcess()">Save</button>
                    <button class="btn btn-orange" (click)="cancelDayEndProcessPage()">Cancel</button>
                </div>
            </div>
        </div>
    </div>



    <!-- Authentication Modal -->

    <div class="modal fade" id="authModal" tabindex="-1" aria-labelledby="authModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="authModalLabel">Authentication</h5>
                    <button type="button" class="btn-close" (click)="closeModalById('authModal')"></button>
                </div>
                <div class="modal-body">
                    <form #authForm="ngForm" (ngSubmit)="submitAuth()">
                        <div class="mb-3">
                            <label for="passcode" class="form-label">Passcode</label>
                            <input type="password" id="passcode" name="passcode" class="form-control" required
                                [(ngModel)]="passcode">
                        </div>
                        <div class="mb-3">
                            <label for="enteredBy" class="form-label">Entered By</label>
                            <select id="enteredBy" name="enteredBy" class="form-select" required
                                [(ngModel)]="enteredBy">
                                <option value=null disabled selected>Select User</option>
                                <option *ngFor="let user of userList" [value]="user.UserId">
                                    {{ user.UserName }}
                                </option>
                            </select>
                        </div>
                        <div class="d-flex justify-content-end">
                            <!-- OK button styled like Save -->
                            <button id="btnAuthOk" type="submit" class="btn btnAS me-1"
                                [disabled]="!passcode || !enteredBy">
                                OK
                            </button>

                            <!-- Cancel button styled like your orange cancel -->
                            <button class="btn btn-orange" type="button" (click)="closeModalById('authModal')">
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>